import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from '../../../../../../../../common/react/utils/translations';

/**
 * @param {object} props - Props.
 * @param props.children
 * @returns {JSX.Element} Component.
 */
export const StatsSectionNavFilterItems = ({ children }) => {
    const [resetFns, setResetFns] = useState([]);

    const addOnResetCallback = (resetFn) => {
        setResetFns((fns) => [...fns, resetFn]);
    };

    return (
        <>
            {children && (
                <div className="stats-leaders-filters">
                    {React.Children.map(children, (child) => (
                        <div className="stats-leaders-filters__item-wrapper">
                            {React.cloneElement(child, { addOnResetCallback })}
                        </div>
                    ))}
                    <div className="stats-leaders-filters__item-wrapper stats-leaders-filters__item-wrapper--reset">
                        <button
                            className="stats-leaders-filter-reset-button"
                            onClick={() => resetFns.forEach((func) => func())}
                        >
                            {getTranslation(
                                'label.statsLeaders.filters.resetButtonText'
                            )}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

StatsSectionNavFilterItems.defaultProps = {
    name: 'StatsSectionNavFilterItems'
};

StatsSectionNavFilterItems.propTypes = {
    children: PropTypes.any.isRequired
};
